import { hexToRGBAValues } from './hex-to-rgba-values';

export const hexToRGBA: (hex: string) => string = (hex: string) => {
	const { r, g, b, a } = hexToRGBAValues(hex);

	return `rgb${a ? 'a' : ''}(${r},${g},${b}${a ? `,${a}` : ''})`;
};
